import { ff_get_cookie } from '../utils/cookie';

/**
 * Grille de développement qui s'affiche par dessus les éléments de la page selon le nombre de colonnes, la largeur des gouttières et la largeur des marges définis dans les propriétés CSS.
 */
export default class FF_Grid {

  cookie_name = 'ff_grid_enabled';

  /**
   * @param {Number|Boolean} [cols] Nombre de colonnes à afficher. (Optionnel).
   */
  constructor(cols) {

    this.enabled = !!ff_get_cookie(this.cookie_name);
    this.grid_values = {
      cols       : (typeof cols === 'number' ? cols : false) || parseInt(getComputedStyle(document.documentElement).getPropertyValue('--grid_cols')) || 12, // Si l'argument "cols" est renseigné on l'utilise
      has_gutters: !!parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--grid_gutter')),
      has_margins: !!parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--grid_margin'))
    };

    // Initialisation
    this.$element = $('<div class="ff-grid"></div>');
    this.$element.appendTo('body');
    if (this.enabled) {
      this.enable();
    }
    else {
      this.disable();
    }

    // Ajout de l'écouteur au resize qui va mettre à jour les colonnes
    $(window).on('resize', $.debounce(() => {
      if (this.enabled) {
        this.enable();
      }
    }, 50));

    // ================================================================================================================
    // Si en mode de développement, on ajoute un keyboard shortcut pour afficher/cacher la grille (CTRL + SHIFT + 4)
    // ================================================================================================================
    if (ff_dev_mode) {
      const key = '$';
      let keyboard_shortcode_is_pressed = false;

      document.addEventListener('keydown', (e) => {
        if (e.key !== key || keyboard_shortcode_is_pressed) return;
        if (e.ctrlKey && e.shiftKey) {
          keyboard_shortcode_is_pressed = true;
          this.toggle();
        }
      });

      document.addEventListener('keyup', (e) => {
        if (e.key == key) {
          keyboard_shortcode_is_pressed = false;
        }
      });
    }

  }

  /**
   * Met à jour les valeurs de variables CSS.
   */
  update() {
    this.grid_values = {
      cols       : (typeof cols === 'number' ? cols : false) || parseInt(getComputedStyle(document.documentElement).getPropertyValue('--grid_cols')) || 12, // Si l'argument "cols" est renseigné on l'utilise
      has_gutters: !!parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--grid_gutter')),
      has_margins: !!parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--grid_margin'))
    };
  }

  /**
   * Bascule l'affichage de la grille.
   * @param {Number|Boolean} [cols] Nombre de colonnes à afficher. Optionnel, utilisera la valeur dans la variable CSS par défaut.
   */
  toggle(cols) {
    const grid_has_to_be_enabled = typeof cols === 'number' || !this.enabled;
    if (grid_has_to_be_enabled) {
      this.enable(cols);
    }
    else {
      this.disable();
    }
  }

  /**
   * Active et affiche la grille.
   * @param {Number|Boolean} [cols] Nombre de colonnes à afficher. Optionnel, utilisera la valeur dans la variable CSS par défaut.
   */
  enable(cols) {

    this.enabled = true;
    this.$element.html('');
    this.update();

    // Ajoute les colonnes requis
    const cols_count = typeof cols === 'number' ? cols : this.grid_values.cols;
    for (let i = 0; i < cols_count; i++) {
      const col = document.createElement('div');
      col.classList.add('ff-grid__col');
      this.$element.append(col);
    }

    // Si le paramètre "cols" a été renseigné avec un nombre de colonnes, on met à jour la variable CSS
    if (typeof cols === 'number') {
      this.$element.css('--grid_cols', cols_count);
    }

    // Mise à jour de l'état
    this.$element.attr('data-enabled', 'true');
    if (this.grid_values.has_gutters) this.$element.addClass('ff-grid--has-gutters', 'true');
    if (this.grid_values.has_margins) this.$element.addClass('ff-grid--has-margins', 'true');
    this.toggle_cookies(true);

  }

  /**
   * Désactive et cache la grille.
   */
  disable() {
    this.enabled = false;
    this.$element
      .removeAttr('data-enabled')
      .html('')
      .removeClass('ff-grid--has-gutters ff-grid--has-margins')
      .css('--grid_cols', '');
    this.toggle_cookies(false);
  }

  /**
   * Met à jour le cookie d'affichage de la grille.
   * @param {Boolean} enable_cookie Si oui ou non on doit ajouter ou retirer le cookie.
   */
  toggle_cookies(enable_cookie) {
    document.cookie = `${this.cookie_name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`; // Reset le cookie
    if (enable_cookie) { // Activation du cookie
      document.cookie = `${this.cookie_name}=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
    }
  }

}
